export default {
  discountedSales: 'discounted sales',
  donation: 'donation',
};
